import { IConfig } from "./Render";

export const TSpan = ({id, children, className, style}:IConfig)=>
{
    return (
        <tspan baseline-shift="super" className={className} style={style}>{children}</tspan>
    );
}